import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import Event20200921 from "./Event20200921";
// import Event20200630 from "./Event20200630";
// import Event20201007_jusul from "./Event20201007_jusul";

import EventContent from "./EventContent";
import EventContentNew from "./EventContentNew";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import PerfectScrollbar from "react-perfect-scrollbar";

class EventItem extends Component {
  state = {};

  render() {
    const { match } = this.props;
    //const { eventIdx } = this.props.childProps;
    let pos;
    let eventIdx;

    if (match) {
      eventIdx = match.params.eventIdx;
      pos = "line";
    }

    if (eventIdx === "" || eventIdx === null || eventIdx === undefined) {
      eventIdx = this.props.childProps.eventIdx;
      pos = "pop";
    }

    //console.log(eventIdx)

    return (
      <Fragment>
        {parseInt(eventIdx) > 287 ? (
          <EventContentNew eventIdx={eventIdx} />
        ) : (
          <EventContent eventIdx={eventIdx} pos={pos} />
        )}

        {/* eventIdx === 278 ? (
                    <Event20200630 
                        eventIdx = {eventIdx}
                    />
                ) : eventIdx === 279 ? (
                    <Event20200921 
                        eventIdx = {eventIdx}
                    />
                ) : eventIdx === 280 ? (
                    <Event20201007_jusul
                        eventIdx = {eventIdx}
                    />
                ) : null */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(EventItem));
